import { useState } from 'react';

import { Facebook as Loader } from 'react-content-loader';

import { uploadAvatar } from '../../api/rest/uploadAvatar';
import { ACCEPTED_IMAGE_UPLOAD_TYPES } from '@config/constants';
import { useAuth } from '@domain/auth/AuthContext';
import { reportMykissClientError } from '@lib/errors/client';
import { useUserInfo } from '@domain/user/useUserInfo';
import { IAvatar } from '@domain/user/types';
import { AvatarSize } from '../Avatar/Avatar';
import { CurrentUserAvatar } from '../Avatar/CurrentUserAvatar';
import { FileDropzone } from '../FileDropzone/FileDropzone';
import { CameraIcon } from '../Icons/CameraIcon';
import { Modal } from '../Modal/Modal';
import { ModalBody } from '../Modal/ModalBody';
import { UserProfileForm } from '../UserProfileForm/UserProfileForm';

export const UserDetails = () => {
  const { user, refetchCurrentUser } = useUserInfo();
  const { getToken } = useAuth();
  const [image, setImage] = useState('');

  const handleUpload = (files: File[]): void => {
    uploadAvatar(files[0]!, getToken)
      .then((data: { image: IAvatar }) => {
        setImage(data.image.base_url);
        refetchCurrentUser().catch((error: unknown) => {
          reportMykissClientError(error);
        });
      })
      .catch((error: unknown) => {
        reportMykissClientError(error);
      });
  };

  if (!user) {
    return <Loader style={{ width: '100%' }} />;
  }
  return (
    <div className="sm:w-col-8 md:w-col-6 mx-auto w-full md:max-w-[425px]">
      <div className="mx-auto my-0 py-6 text-center sm:py-10">
        <Modal
          trigger={props => (
            <button type="button" {...props} className="relative size-[100px] sm:size-[120px]">
              <CurrentUserAvatar size={AvatarSize.MEDIUM_PROFILE} className="w-full" />
              <div className="absolute inset-0 flex size-[100px] items-center justify-center rounded-full bg-black/30 sm:size-[120px]">
                <CameraIcon width="40" height="34" />
              </div>
            </button>
          )}
        >
          <ModalBody>
            <FileDropzone
              id="avatar-upload"
              label="Upload avatar"
              onUpload={handleUpload}
              onClear={() => {
                setImage('');
              }}
              previewUrl={image}
              acceptedFileTypes={ACCEPTED_IMAGE_UPLOAD_TYPES}
            />
          </ModalBody>
        </Modal>
      </div>
      <UserProfileForm
        getAuthToken={getToken}
        currentUser={user}
        refetchUser={refetchCurrentUser}
        labelClassName="text-sm"
      />
    </div>
  );
};
